import { findLast, get, isEmpty } from 'lodash';

export default function getFinalAttribute(entity, attribute)
{
    const baseAttributeValue = get(entity, attribute, '');
    const alternativeAttributes = get(entity, 'alternativeAttributes');

    if (isEmpty(alternativeAttributes))
    {
        return baseAttributeValue;
    }

    const alternativeAttribute = findLast(alternativeAttributes, _alternativeAttribute => _alternativeAttribute.attribute === attribute);

    return !isEmpty(alternativeAttribute) ? alternativeAttribute.value : baseAttributeValue;
}
